import {
  jb_campaign_teaser_css_default
} from "./chunk.VUDQ26EZ.js";
import {
  Spaceable,
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.LK5OUX7S.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-campaign-teaser/jb-campaign-teaser.ts
var JbCampaignTeaser = class extends Spaceable(r) {
  constructor() {
    super(...arguments);
    this.forceHover = false;
    this.headline = "";
    this.subtitle = "";
  }
  _getContentSpacingProperties() {
    return { horizontal: "full-width-md-down", colsMdUp: "none" };
  }
  _tracking(e) {
    const interactionText = e.detail.linkableComponent?.innerText ?? e.detail.linkTag.href;
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e, {
      component_name: "campaign-teaser",
      interaction_text: interactionText
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return ke`
      <section>
        <div class=${Rt({ bg: true, hover: !!this.forceHover })}>
          <jb-picture
            .alt=${this.bgImage?.alt}
            .imgData=${this.bgImage?.imgData}
            ?lazy=${this.bgImage?.lazy}
            fit="cover"
          ></jb-picture>
        </div>
        <div class="content">
          ${this.headline ? ke`<jb-section-headline headline=${this.headline}></jb-section-headline>` : D}
          <div>
            ${this.subtitle ? ke`<h2>${this.subtitle}</h2>` : D}
            <div
              class="btn-panel"
              @mouseenter=${() => {
      this.forceHover = true;
    }}
              @mouseleave=${() => {
      this.forceHover = false;
    }}
              @jb-link:clicked=${this._tracking}
            >
              ${this.button?.text ? ke`<jb-button-primary
                    inverted
                    .link=${this.button.link}
                    >${this.button.text}</jb-button-primary
                  >` : D}
            </div>
          </div>
        </div>
      </section>
    `;
  }
};
JbCampaignTeaser.styles = jb_campaign_teaser_css_default;
__decorateClass([
  n({ type: Object })
], JbCampaignTeaser.prototype, "bgImage", 2);
__decorateClass([
  n({ type: Object })
], JbCampaignTeaser.prototype, "button", 2);
__decorateClass([
  n({ type: Boolean })
], JbCampaignTeaser.prototype, "forceHover", 2);
__decorateClass([
  n()
], JbCampaignTeaser.prototype, "headline", 2);
__decorateClass([
  n()
], JbCampaignTeaser.prototype, "subtitle", 2);
JbCampaignTeaser = __decorateClass([
  customElement("jb-campaign-teaser")
], JbCampaignTeaser);

export {
  JbCampaignTeaser
};
